<template>
  <ablauf-seite
    ablauf="lauf.test"
    :knopf-laufart="laufart"
    knopf-text="Testlauf starten"
    knopf-satz="Erzeugt einen Lauf mit erfundenen Einträgen, nur im Protokoll."
    :knopf-anforderung="anforderung"
    docs-name="testablauf"
  >
    <!-- Das Formular für die Parameter aus G3; der Knopf des Rahmens startet mit diesen Angaben -->
    <template #stand>
      <div class="mt-3">
        <div class="row">
          <div class="col-xl-3">
            <div class="form-group">
              <select v-model="laufart" class="form-control">
                <option value="zeigen">zeigen (zeigt den laufenden Lauf)</option>
                <option value="warten">warten (wartet bei belegter Sperre)</option>
                <option value="einzeln">einzeln (ein Objekt)</option>
              </select>
              <label>Laufart</label>
            </div>
          </div>
          <template v-if="laufart === 'einzeln'">
            <div class="col-xl-3">
              <div class="form-group">
                <select v-model="objektArt" class="form-control">
                  <option value="auftrag">Auftrag</option>
                  <option value="person">Person</option>
                  <option value="firma">Firma</option>
                </select>
                <label>Objektart</label>
              </div>
            </div>
            <div class="col-xl-3">
              <div class="form-group">
                <input v-model.trim="objektId" class="form-control" type="text" placeholder=" " />
                <label>Objekt-ID</label>
              </div>
            </div>
          </template>
        </div>

        <div class="row">
          <div v-for="feld in zahlFelder" :key="feld.key" class="col-xl-2">
            <div class="form-group">
              <input v-model.number="parameter[feld.key]" class="form-control" type="number" min="0" placeholder=" " />
              <label>{{ feld.label }}</label>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-xl-2">
            <div class="form-check">
              <input id="testablauf-fehlschlag" v-model="parameter.fehlschlag" type="checkbox" class="form-check-input" />
              <label for="testablauf-fehlschlag">Fehlschlag</label>
            </div>
          </div>
          <div class="col-xl-2">
            <div class="form-check">
              <input id="testablauf-zeitplan" v-model="parameter.zeitplan" type="checkbox" class="form-check-input" />
              <label for="testablauf-zeitplan">wie aus dem Zeitplan</label>
            </div>
          </div>
          <div class="col-xl-2">
            <div class="form-check">
              <input id="testablauf-test" v-model="test" type="checkbox" class="form-check-input" />
              <label for="testablauf-test">Testlauf</label>
            </div>
          </div>
        </div>

        <div class="row align-items-center">
          <div class="col-xl-3">
            <div class="form-group mb-0">
              <input v-model.trim="laufId" class="form-control" type="text" placeholder=" " @keyup.enter="laufOeffnen" />
              <label>Lauf-ID</label>
            </div>
          </div>
          <div class="col-xl-3">
            <button type="button" class="btn btn-default" :disabled="!laufId" @click="laufOeffnen">
              Lauf öffnen
            </button>
          </div>
        </div>
      </div>
    </template>
  </ablauf-seite>
</template>

<script>
import page from "@/mixins/Page";
import AblaufSeite from "@/components/Lauf/AblaufSeite.vue";

/**
 * Seite des Testablaufs lauf.test im Rahmen für die Seite je Ablauf (G3, ab G4 im Rahmen, Konzept 12.7). Der
 * Knopf des Rahmens startet die gewählte Laufart, ohne Wahl „zeigen“: läuft schon ein Lauf, zeigt die
 * Lauf-Ansicht diesen. Nur nutzbar, wo lauf.test angemeldet ist (edu-dev, edu-staging).
 */
export default {
  name: "Testablauf",
  components: {
    AblaufSeite,
  },
  mixins: [page],
  data() {
    return {
      laufart: "zeigen",
      objektArt: "auftrag",
      objektId: "",
      test: false,
      laufId: "",
      parameter: {
        anzahl: 10,
        fehler: 0,
        nichtVerarbeitet: 0,
        markiert: 0,
        dauerSekunden: 0,
        fehlschlag: false,
        zeitplan: false,
      },
      zahlFelder: [
        { key: "anzahl", label: "Anzahl Einträge" },
        { key: "fehler", label: "davon mit Fehler" },
        { key: "nichtVerarbeitet", label: "davon nicht verarbeitet" },
        { key: "markiert", label: "davon markiert" },
        { key: "dauerSekunden", label: "Dauer in Sekunden" },
      ],
    };
  },
  computed: {
    navbarTitel() {
      return "Testablauf";
    },
    /** Was der Knopf des Rahmens zu Ablauf und Laufart mitschickt */
    anforderung() {
      const einzeln = this.laufart === "einzeln";
      return {
        objektArt: einzeln ? this.objektArt : null,
        objektId: einzeln ? this.objektId : null,
        test: this.test,
        parameter: this.parameter,
      };
    },
  },
  methods: {
    laufOeffnen() {
      if (!this.laufId) return;
      this.$bus.$emit("lauf-ansicht-oeffnen", { lauf: this.laufId });
    },
  },
};
</script>
